import React from 'react';
import Input from './Input';

const Main = () => {
    return (
        <div>
            <div className="main-container">
                <h1>Create short links!</h1>
                <p>Shrink it is url shortner website which helps you to get rid from long url. Which helps you to reach your result instantly. Generate your link just by one click below...</p>
                <Input />
            </div>
        </div>
    )
}

export default Main;
